import { Box } from "@mui/material";
import ConversationsStore from "components/Conversations/Stores/ConversationsStore";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "utils/useStore";
import SafetyEventsSection from "./SafetyEventsSection";
import EddySection from "./EddySection";
import KeyInsightsContainer from "../KeyInsightsContainer";
import SummarySection from "./SummarySection";
import { SmartBanner } from "components/SmartBanner/SmartBanner";
import ContextStore from "stores/ContextStore";
import { ApplicationFiltersStore } from "stores/ApplicationFilters/ApplicationFiltersStore";
import { AcxTranscriptionStore } from "components/UI/AcxTranscription/Stores/AcxTranscriptionStore";

const ConversationSummaryHighlights = observer(
    ({ setTab }: { setTab: React.Dispatch<React.SetStateAction<number>> }) => {
        const store = useStore(ConversationsStore);

        const contextStore = useStore(ContextStore);
        const applicationFiltersStore = useStore(ApplicationFiltersStore);
        const transcriptionStore = useStore(AcxTranscriptionStore);

        // Set the conversation in the SmartBannerContext when loading into a conversation
        React.useEffect(() => {
            if (store.selectedConversation) {
                contextStore.setupContext({
                    actionTaken: "FocusConversation",
                    filters:
                        applicationFiltersStore.currentlyAppliedFilters ?? {},
                    conversationStore: store,
                    transcriptionStore: transcriptionStore,
                    onClick: () => {
                        setTab(1);
                    },
                });
            }
            // Only run when the conversation changes
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [store.selectedConversation]);

        return (
            <Box
                sx={{
                    padding: 3,
                    gap: 2,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <SmartBanner title="Why this result?" />
                <SummarySection store={store} />
                {store.focusedConversationInsights && (
                    <KeyInsightsContainer
                        insights={store.focusedConversationInsights}
                    />
                )}
                {store.selectedConversation?.hasSafetyEvent.result && (
                    <SafetyEventsSection setTab={setTab} store={store} />
                )}
                {store.selectedConversation?.hasEddyEffect.result && (
                    <EddySection setTab={setTab} store={store} />
                )}
            </Box>
        );
    },
);

export default ConversationSummaryHighlights;
